// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1RBr3","notes":"Notes_notes__3NLsL"};